function plural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
  return many;
}

interface SeatingStatsCardProps {
  seated: number;
  total: number;
  tables: number;
  warnings?: number;
  onWarningsClick?: () => void;
  onAutoSeat?: () => void;
  autoSeatDisabled?: boolean;
}

export default function SeatingStatsCard({
  seated,
  total,
  tables,
  warnings = 0,
  onWarningsClick,
  onAutoSeat,
  autoSeatDisabled,
}: SeatingStatsCardProps) {
  const pct = total > 0 ? Math.round((seated / total) * 100) : 0;
  const c = 2 * Math.PI * 25;
  const offset = c * (1 - pct / 100);

  return (
    <div className="st-stat">
      <svg className="st-stat__ring" viewBox="0 0 58 58" aria-hidden="true">
        <defs>
          <linearGradient id="st-ring-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" style={{ stopColor: 'var(--st-secondary)' }} />
            <stop offset="1" style={{ stopColor: 'var(--st-accent)' }} />
          </linearGradient>
        </defs>
        <circle
          cx="29" cy="29" r="25" fill="none" strokeWidth="4"
          style={{ stroke: 'color-mix(in srgb, var(--st-bg) 18%, transparent)' }}
        />
        <circle
          cx="29" cy="29" r="25" fill="none" strokeWidth="4" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={offset} transform="rotate(-90 29 29)"
          style={{ stroke: 'url(#st-ring-grad)' }}
        />
        <text
          x="29" y="33" textAnchor="middle" fontSize="12" fontWeight="700"
          style={{ fill: 'var(--st-bg)', fontFamily: 'Manrope, sans-serif' }}
        >
          {pct}%
        </text>
      </svg>
      <div>
        <div className="st-stat__value">
          {seated} из {total}
        </div>
        <small className="st-stat__sub">
          гостей рассажено · {tables} {plural(tables, 'стол', 'стола', 'столов')}
        </small>
        <div className="st-stat__row">
          {warnings > 0 && (
            <button type="button" className="st-stat__warn" onClick={onWarningsClick}>
              <span aria-hidden="true">⚠</span>
              {warnings} {plural(warnings, 'предупреждение', 'предупреждения', 'предупреждений')}
            </button>
          )}
          {onAutoSeat && (
            <button type="button" className="st-stat__auto" disabled={autoSeatDisabled} onClick={onAutoSeat}>
              Рассадить автоматически
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
